import { connect } from 'react-redux';
import { actionCreators } from 'state/actions';
import { withQuoteId } from 'components/contexts';
import { CloseTile as CloseTileRaw } from './CloseTile';
import { mapDispatchToPropsCloseTile } from './connectCloseTile';

const connectCloseTile = connect(null, mapDispatchToPropsCloseTile(actionCreators));

export const CloseTile = withQuoteId(connectCloseTile(CloseTileRaw));
